import React from "react";
import { Grid } from "semantic-ui-react";
import { LayoutParser } from "@fishrmn/fishrmn-utils";

const noThemeComponentTypes = ["PageTitle", "Title", "SocialMedia"];

const getItemContainerClassName = componentName => {
  const hasTheme = noThemeComponentTypes.indexOf(componentName) === -1;

  return hasTheme ? "grid-item-container-with-theme" : "grid-item-container";
};

const getSectionClassNames = isPageTitle => {
  const baseClass = "section-container";
  return isPageTitle ? `${baseClass} section-container-no-padding` : baseClass;
};

const getSectionStyling = isPageTitle => {
  return isPageTitle ? {margin: "-2rem 0% 1rem 0%" } : {};
};

const SectionLayout = ({
  sectionLayoutConfiguration,
  isPageTitle,
  isReactElement
}) => {
  let gridProps;
  let sectionLayout;
  let componentLayouts;
  let components;
  let getChildComponent;
  let createLayoutColumnProps;
  if (!isReactElement) {
    gridProps = sectionLayoutConfiguration.gridProps;
    sectionLayout = sectionLayoutConfiguration.sectionLayout;
    componentLayouts = sectionLayout.componentLayouts;
    components = sectionLayout.components;

    const layoutParser = LayoutParser();
    getChildComponent = layoutParser.getChildComponent;
    createLayoutColumnProps = layoutParser.createLayoutColumnProps;
  } else {
    sectionLayout = sectionLayoutConfiguration;
  }
  return (
    <div
      className={getSectionClassNames(isPageTitle)}
      style={getSectionStyling(isPageTitle)}
    >
      {isReactElement ? (
        sectionLayout
      ) : (
        <Grid {...gridProps}>
          {componentLayouts.map(componentLayout => {
            const { componentName, ...rest } = componentLayout;
            const childComponent = getChildComponent(components, componentName);
            const columnProps = createLayoutColumnProps(rest);
            return (
              <Grid.Column key={componentName} {...columnProps}>
                <div className={getItemContainerClassName(componentName)}>
                  {childComponent}
                </div>
              </Grid.Column>
            );
          })}
        </Grid>
      )}
    </div>
  );
};

export default SectionLayout;
